/**
 * @file forum
 * @author wangzhuang
 */

import {
    GET_CMSAPI_GETHOMEPAGE,
    GET_USER_LOGINSTATE,
    GET_ARTICLE_LIST,
    GET_NAVIGATION_LIST,
    GET_NAVLIST_INDEX
} from '../actions/ActionTypes';

export function cmsapiHomepagea(state = {}, action) {
    switch (action.type) {
        case GET_CMSAPI_GETHOMEPAGE:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function userLoginstate(state = {}, action) {
    switch (action.type) {
        case GET_USER_LOGINSTATE:
            state = action.data;
            return state;
        default:
            return state;
    }
}

export function articleList(state = {}, action) {
    switch (action.type) {
        case GET_ARTICLE_LIST:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function navigationList(state = {}, action) {
    switch (action.type) {
        case GET_NAVIGATION_LIST:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function navListIndex(state = {}, action) {
    switch (action.type) {
        case GET_NAVLIST_INDEX:
            state = action.data;
            return state;
        default:
            return {index: 0};
    }
}


// WEBPACK FOOTER //
// ./src/reducers/home.js